var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1109 14.7777C13.1109 16.005 14.1058 16.9999 15.3331 16.9999C16.5604 16.9999 17.5554 16.005 17.5554 14.7777C17.5554 13.5504 16.5604 12.5555 15.3331 12.5555C14.1058 12.5555 13.1109 13.5504 13.1109 14.7777Z",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14.7783L17.5556 14.7783",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1112 14.7783L2.00008 14.7783",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8891 8.11115C10.8891 6.88386 9.89417 5.88893 8.66687 5.88893C7.43957 5.88893 6.44465 6.88386 6.44465 8.11115C6.44465 9.33845 7.43957 10.3334 8.66687 10.3334C9.89417 10.3334 10.8891 9.33845 10.8891 8.11115Z",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00001 8.11008L6.44445 8.11008",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8888 8.11008L21.9999 8.11008",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon_filter.bea5af225480dfd140d9b56274e6ca2a.svg";
export { ForwardRef as ReactComponent };